export const Settings = {
    selectorDocumentContent: '.document-content, .blockContent',
    selectorStructure: 'body, .document-content, .blockContent, [id]:not([id^=dx-])',
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/anchor/config.tsx